import {useCallback} from 'react';
import {getChatSessionId} from '@scripttag/helpers/sessionHelpers';

/**
 * @typedef {'welcomeVisitorTriggered' | 'welcomeVisitorEngaged' | 'subscribeNewsletterTriggered' | 'subscribeNewsletterEngaged'} Activity
 */

/**
 * todo triggered on every new visitor to store, causing too much firestore read and write, might be removed later
 *
 * @param {boolean} isPreview
 * @param {function} putData
 * @returns {{ addActivity: (activity: Activity) => Promise<void> }}
 */
export function useChatbotActivities(isPreview, putData) {
  const addActivity = useCallback(
    async activity => {
      try {
        const sessionId = getChatSessionId();
        if (isPreview || !putData || window.self !== window.top || !sessionId) return;
        await putData('/chatbotActivities', {activity, sessionId});
      } catch (err) {
        console.log(err);
      }
    },
    [isPreview, putData]
  );
  return {addActivity};
}
